module.exports = __webpack_public_path__ + "img/pick4.6767b878.png";